// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39xJ9","delete":"styles_delete__28BcY","update":"styles_update__nBOsH","add":"styles_add__1pUY7"};